import React from "react";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";

function Calender({ handleDateChange }) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
                components={[
                    "DatePicker",
                    "MobileDatePicker",
                    "DesktopDatePicker",
                    "StaticDatePicker",
                ]}
            >
                <DemoItem>
                    <StaticDatePicker
                        defaultValue={dayjs(new Date())}
                        disableToolbar
                        isLandscape={false}
                        onChange={handleDateChange}
                    />
                </DemoItem>
            </DemoContainer>
        </LocalizationProvider>
    );
}

export default Calender;
